/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import './index.scss'
import { Select, Modal, Radio, Button, Form, Input, DatePicker, Tabs } from 'antd';
import { FileSearchOutlined, SearchOutlined, InsertRowBelowOutlined, UnorderedListOutlined } from '@ant-design/icons';
import WebViewer from '@pdftron/webviewer';
import { useNavigate, Link } from "react-router-dom";
import { checkIsActive, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { requestPOST, requestGET, HOST_API, FILE_URL, requestPOST_URL } from '../../../../utils/baseAPI'
import { useAuth } from '../../../modules/auth';
import dayjs from 'dayjs';
import moment from 'moment';

import ZoomMtgEmbedded from '@zoomus/websdk/embedded';

import { DocumentItem } from './components/DocumentItem'
import _ from 'lodash';
import TableList from 'src/app/components/TableList';


// const documents = [
//   {
//     "id": 1,
//     "avatar": 'luan-an-on-dinh-cua-vo-fgm-co-lo-rong-va-panel-sandwich-fg-c_Ckn8CTwkbQ.jpg',
//     "title": 'Luận án Ổn định của vỏ fgm có lỗ rỗng và Panel Sandwich Fg-Cntrc với các cạnh biên chịu liên kết đàn hồi',
//     "description": '1.1.1. Vật liệu composite cơ tính biến đổi (FGM) Vật liệu cơ tính biến đổi (Functionally Graded Material), thường được viết tắt là FGM, là một loại composite hai thành phần được cấu thành từ ceramic và kim loại trong đó tỷ lệ thể tích của mỗi thành phần được biến đổi trơn và liên tục theo một phương nhất định của kết cấu [1,2]. ',
//     "storage": 8.3,
//     "download": 80,
//   },
//   {
//     "id": 2,
//     "avatar": 'luan-an-nghien-cuu-on-dinh-chuyen-dong-khi-lam-viec-cua-lien_cKpf1xrNJG.jpg',
//     "title": 'Luận án Ổn định của vỏ fgm có lỗ rỗng và Panel Sandwich Fg-Cntrc với các cạnh biên chịu liên kết đàn hồi',
//     "description": '1.1.1. Vật liệu composite cơ tính biến đổi (FGM) Vật liệu cơ tính biến đổi (Functionally Graded Material), thường được viết tắt là FGM, là một loại composite hai thành phần được cấu thành từ ceramic và kim loại trong đó tỷ lệ thể tích của mỗi thành phần được biến đổi trơn và liên tục theo một phương nhất định của kết cấu [1,2]. ',
//     "storage": 8.3,
//     "download": 80,
//   },
//   {
//     "id": 3,
//     "avatar": 'luan-an-nghien-cuu-nang-cao-do-chinh-xac-co-cau-an-dao-dung_dyj5bVzyKV.jpg',
//     "title": 'Luận án Ổn định của vỏ fgm có lỗ rỗng và Panel Sandwich Fg-Cntrc với các cạnh biên chịu liên kết đàn hồi',
//     "description": '1.1.1. Vật liệu composite cơ tính biến đổi (FGM) Vật liệu cơ tính biến đổi (Functionally Graded Material), thường được viết tắt là FGM, là một loại composite hai thành phần được cấu thành từ ceramic và kim loại trong đó tỷ lệ thể tích của mỗi thành phần được biến đổi trơn và liên tục theo một phương nhất định của kết cấu [1,2]. ',
//     "storage": 8.3,
//     "download": 80,
//   },
//   {
//     "id": 4,
//     "avatar": 'luan-an-phat-trien-va-toi-uu-hoa-cac-bo-dinh-vi-su-dung-co-c_bqcQOWkbF6.jpg',
//     "title": 'Luận án Ổn định của vỏ fgm có lỗ rỗng và Panel Sandwich Fg-Cntrc với các cạnh biên chịu liên kết đàn hồi',
//     "description": '1.1.1. Vật liệu composite cơ tính biến đổi (FGM) Vật liệu cơ tính biến đổi (Functionally Graded Material), thường được viết tắt là FGM, là một loại composite hai thành phần được cấu thành từ ceramic và kim loại trong đó tỷ lệ thể tích của mỗi thành phần được biến đổi trơn và liên tục theo một phương nhất định của kết cấu [1,2]. ',
//     "storage": 8.3,
//     "download": 80,
//   },
//   {
//     "id": 5,
//     "avatar": 'luan-an-on-dinh-cua-vo-fgm-co-lo-rong-va-panel-sandwich-fg-c_Ckn8CTwkbQ.jpg',
//     "title": 'Luận án Ổn định của vỏ fgm có lỗ rỗng và Panel Sandwich Fg-Cntrc với các cạnh biên chịu liên kết đàn hồi',
//     "description": '1.1.1. Vật liệu composite cơ tính biến đổi (FGM) Vật liệu cơ tính biến đổi (Functionally Graded Material), thường được viết tắt là FGM, là một loại composite hai thành phần được cấu thành từ ceramic và kim loại trong đó tỷ lệ thể tích của mỗi thành phần được biến đổi trơn và liên tục theo một phương nhất định của kết cấu [1,2]. ',
//     "storage": 8.3,
//     "download": 80,
//   },
//   {
//     "id": 6,
//     "avatar": 'luan-an-on-dinh-cua-vo-fgm-co-lo-rong-va-panel-sandwich-fg-c_Ckn8CTwkbQ.jpg',
//     "title": 'Luận án Ổn định của vỏ fgm có lỗ rỗng và Panel Sandwich Fg-Cntrc với các cạnh biên chịu liên kết đàn hồi',
//     "description": '1.1.1. Vật liệu composite cơ tính biến đổi (FGM) Vật liệu cơ tính biến đổi (Functionally Graded Material), thường được viết tắt là FGM, là một loại composite hai thành phần được cấu thành từ ceramic và kim loại trong đó tỷ lệ thể tích của mỗi thành phần được biến đổi trơn và liên tục theo một phương nhất định của kết cấu [1,2]. ',
//     "storage": 8.3,
//     "download": 80,
//   },
//   {
//     "id": 7,
//     "avatar": 'luan-an-on-dinh-cua-vo-fgm-co-lo-rong-va-panel-sandwich-fg-c_Ckn8CTwkbQ.jpg',
//     "title": 'Luận án Ổn định của vỏ fgm có lỗ rỗng và Panel Sandwich Fg-Cntrc với các cạnh biên chịu liên kết đàn hồi',
//     "description": '1.1.1. Vật liệu composite cơ tính biến đổi (FGM) Vật liệu cơ tính biến đổi (Functionally Graded Material), thường được viết tắt là FGM, là một loại composite hai thành phần được cấu thành từ ceramic và kim loại trong đó tỷ lệ thể tích của mỗi thành phần được biến đổi trơn và liên tục theo một phương nhất định của kết cấu [1,2]. ',
//     "storage": 8.3,
//     "download": 80,
//   },
//   {
//     "id": 8,
//     "avatar": 'luan-an-on-dinh-cua-vo-fgm-co-lo-rong-va-panel-sandwich-fg-c_Ckn8CTwkbQ.jpg',
//     "title": 'Luận án Ổn định của vỏ fgm có lỗ rỗng và Panel Sandwich Fg-Cntrc với các cạnh biên chịu liên kết đàn hồi',
//     "description": '1.1.1. Vật liệu composite cơ tính biến đổi (FGM) Vật liệu cơ tính biến đổi (Functionally Graded Material), thường được viết tắt là FGM, là một loại composite hai thành phần được cấu thành từ ceramic và kim loại trong đó tỷ lệ thể tích của mỗi thành phần được biến đổi trơn và liên tục theo một phương nhất định của kết cấu [1,2]. ',
//     "storage": 8.3,
//     "download": 80,
//   },
// ]

const { Option } = Select;

const DashboardWrapper = (props) => {

  const { danhMucTaiLieuMinhChungId } = props;
  const { currentUser, auth } = useAuth();

  const client = ZoomMtgEmbedded.createClient();

  const dispatch = useDispatch();
  let navigate = useNavigate();
  const viewer = useRef(null);

  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const [code, setCode] = useState(null);
  const [action, setAction] = useState([]);
  const [visible, setVisible] = useState(false);
  const [PDFTron, setPDFTron] = useState(null);

  const [documents, setDocuments] = useState([]);
  const [dataSearch, setDataSearch] = useState(null);
  const [dataSearchTemp, setDataSearchTemp] = useState(null);
  const [phongBans, setDataPhongBan] = useState([]);
  const [phongBanID, setDataPhongBanID] = useState(null);

  const [size, setSize] = useState(10);
  const [count, setCount] = useState('');
  const [offset, setOffset] = useState(1);


  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;
  const rangeConfig = {
    rules: [
      {
        type: 'array',
        required: false,
        message: 'Chọn thời gian!',
      },
    ],
  };
  const [sizeView, setSizeView] = useState("1");


  useEffect(() => {
    const fetchData = async () => {

      var body = { "advancedSearch": { "fields": ["name", "shortName", "code"], "keyword": null }, "pageNumber": 1, "pageSize": 100, "orderBy": ["createdOn DESC"] }
      var data = await requestPOST(`api/v1/cocautochucs/getphongbanfix`, body);
      var res = data.data ?? [];
      setDataPhongBan(res);
      if (res.length > 0) setDataPhongBanID(res[0].id)

    };
    fetchData()
    return () => {

    }
  }, [])

  //console.log(phongBans)


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await requestPOST(`api/v1/tailieuminhchungs/search/congbo`,

          _.assign(
            {
              advancedSearch: {
                fields: ['tieuDe', 'moTa'],
                keyword: dataSearch?.keywordSearch ?? null,
              },
              pageNumber: 1,
              pageSize: 1000,
              orderBy: ['createdOn DESC'],
              danhMucTaiLieuMinhChungId: danhMucTaiLieuMinhChungId,
              phongBanId: phongBanID

            },
            dataSearch
          ));
        setDocuments(res?.data ?? []);
        setCount(res?.totalCount ?? 0);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchData();

    return () => {
      setDocuments([]);
    };
  }, [dataSearch, phongBanID]);


  const getDynamicContent = () => {
    return documents.length > 0 ? (
      documents.map((item) => (
        <div className={sizeView === "1" ? 'col-md-4 col-lg-3 col-xxl-2 pb-5' : 'col-md-12 col-lg-6 pb-5'}>
          <DocumentItem
            key={item?.id}
            id={item?.id}
            sizeView={sizeView}
            avatar={item?.anhBia === null ? "/media/books/book-cover.png" : item?.anhBia}
            title={item?.tieuDe}
            description={item?.moTa}
            storage={20}
            download={10}
            date={moment(item?.ngayCongBo).format("DD/MM/yyyy")}
          />
        </div>
      )
      )
    ) : ''
  };

  const tabOnChange = (key) => {
    setDataPhongBanID(key)
  };

  const columns = [
    {
      title: <div style={{ textAlign: 'center' }}>STT</div>,
      dataIndex: 'index',
      key: 'index',
      width: '5%',
      render: (text, record, index) => {
        return (
          <div className='d-flex flex-column centered-content'>
            <span>{(offset - 1 ) * size + index + 1}</span> {/* Cột số thứ tự bắt đầu từ 1 */}
          </div>
        );
      },
    },
    {
      title: <div style={{ textAlign: 'center' }}>Ảnh bìa</div>,
      dataIndex: '',
      key: '',
      width: '10%',
      render: (text, record, index) => {
        return (
          <>
            <div className='d-flex flex-column centered-content'>
              <Link to={`/docs-detail/${record?.id}`}>

                <img width={50} src={toAbsoluteUrl(`${FILE_URL}${record?.anhBia === null || record?.anhBia === "" ? '/media/books/book-cover.png' : record?.anhBia}`)} onError={toAbsoluteUrl('/media/books/book-cover.png')} alt={"Ảnh bìa"}></img>

              </Link>
              {/* <span>{record?.tieuDe}</span> */}
            </div>
          </>
        );
      },
    },
    {
      title: <div style={{ textAlign: 'center' }}>Tiêu đề</div>,
      dataIndex: '',
      key: 'tieuDe',
      width: '30%',
      render: (text, record, index) => {
        return (
          <>
            <div className='d-flex flex-column'>
              <Link to={`/docs-detail/${record?.id}`}>{record?.tieuDe}</Link>
              {/* <span>{record?.tieuDe}</span> */}
            </div>
          </>
        );
      },
    },
    {
      title: <div style={{ textAlign: 'center' }}>Mô tả</div>,
      dataIndex: '',
      key: 'moTa',
      // width: '700px',
      render: (text, record, index) => {

        var res = record?.moTa;

        if (res?.length > 300) {
          res = res.slice(0, 299) + " ..."
        }

        return (
          <>
            <div className='d-flex flex-column'>
              <Link to={`/docs-detail/${record?.id}`}>{res}</Link>
              {/* <span>{res}</span> */}
            </div>
          </>
        );
      },
    },
    {
      title: <div style={{ textAlign: 'center' }}>Thao tác</div>,
      dataIndex: '',
      key: '',
      width: '10%',
      render: (text, record) => {
        return (
          (<div className='d-flex flex-column centered-content'>
            <a
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 mb-1'
              data-toggle='m-tooltip'
              title='Chi tiết'
              onClick={() => {
                //handleButton(`chi-tiet`, record);
              }}
            >
              <Link to={`/docs-detail/${record?.id}`}><i className='fa fa-eye'></i></Link>
            </a>
          </div>
          )
        );
      },
    },
  ];

  return (
    <>
      {/* BEGIN: FORM-FILTER */}
      <div className="form-filter mb-3 mb-lg-6 d-flex">
        <Form form={form} name="horizontal_search" layout="inline">
          <Form.Item
            name="key"
          // rules={[
          //   {
          //     required: true,
          //     message: 'Vui lòng nhập nội dung cần tìm kiếm!',
          //   },
          // ]}
          >
            <Input style={{ width: 400 }} prefix={<FileSearchOutlined className="site-form-item-icon" />} placeholder="Nhập nội dung tìm kiếm"
              onChange={(e) => {
                setDataSearchTemp({ ...dataSearch, keywordSearch: e.target.value });
              }}
            />
          </Form.Item>
          {/* <Form.Item name="range-picker" {...rangeConfig}>
            <RangePicker />
          </Form.Item> */}
          <Form.Item shouldUpdate>
            {() => (
              <Button
                type="primary"
                htmlType="submit"

                onClick={() => {
                  setDataSearch(dataSearchTemp);

                }}

              >
                <SearchOutlined /> Tìm kiếm
              </Button>
            )}
          </Form.Item>
        </Form>
        {/* <div className="filter-sort">
          <span title="Danh sách"></span>
          <span title="Danh sách dạng lưới"></span>

          <Radio.Group value={sizeView} onChange={(e) => setSizeView(e.target.value)}>
            <Radio.Button value="1" title="Hiển thị dạng lưới"><InsertRowBelowOutlined /></Radio.Button>
            <Radio.Button value="2" title="Hiển thị dạng danh sách"><UnorderedListOutlined /></Radio.Button>
          </Radio.Group>
        </div> */}
      </div>
      <div className="row">
        {
          phongBans.length > 0 ? (
            <Tabs
              onChange={tabOnChange}
              type="card"
              items={phongBans.map((item, i) => {
                return {
                  label: `${item.name}`,
                  key: item.id,
                  //children: getDynamicContent(),
                };
              })}
            />
          ) : ""
        }

        {
          // documents.length > 0 ? (
          //   documents.map((item) => (
          //     <div className={sizeView === "1" ? 'col-md-4 col-lg-3 col-xxl-2 pb-5' : 'col-md-12 col-lg-6 pb-5'}>
          //       <DocumentItem
          //         key={item?.id}
          //         id={item?.id}
          //         sizeView={sizeView}
          //         avatar={item?.anhBia === null ? "/media/books/book-cover.png" : item?.anhBia}
          //         title={item?.tieuDe}
          //         description={item?.moTa}
          //         storage={20}
          //         download={10}
          //         date={moment(item?.ngayCongBo).format("DD/MM/yyyy")}
          //       />
          //     </div>
          //   )
          //   )
          // ) : ''

          <div className='card-body card-dashboard px-3 py-3'>
            <div className='card-dashboard-body table-responsive'>
              <TableList
                dataTable={documents}
                columns={columns}
                isPagination={true}
                size={size}
                count={count}
                setOffset={setOffset}
                setSize={setSize}
                loading={loading}
              />
            </div>
          </div>


        }

      </div>
    </>
  )
}

export { DashboardWrapper }
